var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "dmp",
          rawName: "v-dmp",
          value: {
            action: "click,pop",
            targetid: _vm.item.iId || _vm.item.iVideoId || _vm.item.vid,
            targettype: "video",
            title: _vm.item.sTitle || _vm.item.articleTitle,
            from: _vm.item.iBiz ? "v4" : "doujin"
          },
          expression:
            "{action:'click,pop', targetid: item.iId||item.iVideoId ||item.vid, targettype: 'video', title: item.sTitle||item.articleTitle, from:item.iBiz?'v4':'doujin'}"
        }
      ],
      staticClass: "igc-v4-video",
      style: { background: _vm.mColor(7) },
      on: { click: _vm.to }
    },
    [
      _c("div", { staticClass: "ig--info" }, [
        _c(
          "div",
          { staticClass: "ig--title", style: { color: _vm.mColor(1) } },
          [_vm._v(_vm._s(_vm.item.sTitle || _vm.item.articleTitle))]
        ),
        _c(
          "div",
          { staticClass: "ig--desc", style: { color: _vm.mColor(3) } },
          [
            _c("sui-icon", {
              attrs: { fill: _vm.mColor(3), name: "eye-outline" }
            }),
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm._f("mcFormatNumber")(
                    _vm.item.iTotalPlay || _vm.item.totalVV
                  )
                ) +
                "\n            "
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "ig--poster" },
        [
          _c("div", { staticClass: "ig--icon" }),
          _c("sui-image", {
            attrs: {
              src: _vm.mImageView(
                _vm.item.sIMG || _vm.item.imgUrl,
                "/1/w/315/h/210"
              )
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }